export * from './PaymentTermsTable';
